import React from 'react';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import { useDMR, useFee } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import Table from '../../Table.js';
import CopyToClipboard from '../../CopyToClipboard.js';
import Badge from '../../Badge.js';
import THEME from '../../../theme.js';
import Alert from '../../Alert.js';
import { getOwnerFromDMR, getUserFromDMR, } from '@debbie/common/dist/bespoke/apcoa/index.js';
import { addressToString } from '@debbie/common/dist/index.js';
const DMRCmp = (props) => {
    const { caseVoucher } = props;
    const feeLoadable = useFee(caseVoucher.referenceId);
    const fee = h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    const dmrLoadable = useDMR(caseVoucher.referenceId, fee?.registrationNo);
    const dmr = h.isLoaded(dmrLoadable) ? dmrLoadable.data : null;
    const user = dmr && getUserFromDMR(dmr);
    const owner = dmr && getOwnerFromDMR(dmr);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: '-10px' } },
            (h.isError(dmrLoadable) || h.isError(feeLoadable)) && (React.createElement(Alert, { message: 'Dataen kunne ikke hentes fra Navision.', style: {
                    backgroundColor: THEME.DANGEROUS,
                }, size: "small" })),
            fee && dmr ? (React.createElement(React.Fragment, null,
                React.createElement(Table, { zebra: true },
                    React.createElement("tr", null,
                        React.createElement("td", null, "Reg.nr."),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, { text: fee.registrationNo }, fee.registrationNo))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "M\u00E6rke"),
                        React.createElement("td", null, fee.vehicleBrandCode)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Nationalitet"),
                        React.createElement("td", null, fee.vehicleNationalityCode === 'DK' ? (fee.vehicleNationalityCode) : (React.createElement(Badge, { theme: THEME.DANGEROUS }, fee.vehicleNationalityCode)))),
                    owner && (React.createElement("tr", null,
                        React.createElement("td", null, "Ejer"),
                        React.createElement("td", null,
                            React.createElement("b", null, owner.name),
                            " (",
                            owner.isCompany ? 'Virksomhed' : 'Privatperson',
                            ")",
                            React.createElement("br", null),
                            addressToString(owner.address),
                            React.createElement("br", null),
                            owner.birthdate,
                            React.createElement("br", null),
                            owner.isCompany ? 'Virksomhed' : 'Privatperson',
                            owner.cvr && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                "CVR: ",
                                owner.cvr))))),
                    user && (React.createElement("tr", null,
                        React.createElement("td", null, "Bruger"),
                        React.createElement("td", null,
                            React.createElement("b", null, user.name),
                            " (",
                            user.isCompany ? 'Virksomhed' : 'Privatperson',
                            ")",
                            React.createElement("br", null),
                            addressToString(user.address),
                            React.createElement("br", null),
                            user.birthdate,
                            user.cvr && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                "CVR: ",
                                user.cvr)))))))) : (!(h.isError(dmrLoadable) || h.isError(feeLoadable)) && (React.createElement(React.Fragment, null,
                React.createElement(PlaceholderLoader, { width: "200px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "120px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "140px" })))))));
};
export default DMRCmp;
//# sourceMappingURL=DMR.js.map